exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a {\n  color: red;\n}\n.el-tooltip__popper {\n  max-width: 80% !important;\n}\n", ""]);

// exports
